import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { AffiliategetProfile } from "./affiliateSlice";

const initialState = {
    isLoading: false,
    isResending: false,
    loginInfo: {},
    forgotPasswordData: {},
    verifyOtpData: {},
    resetPasswordData: {},
    errorMsg: "",
    isError: false
}

export const loginAffiliateWithGoogle = createAsyncThunk('loginAffiliateWithGoogle', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.loginAffiliateWithGoogle(body);
        dispatch(setLoading(true))

        console.log(data,"data!--------");
        
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setLoginData(true))
                Toastify.success("Affiliate Login successful");
                localStorage.setItem("affiliatetoken",data.data.token)
                localStorage.removeItem("token")

        }
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const affiliateLogin = createAsyncThunk('affiliateLogin', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.AffiliateLogin(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setLoginData(body))
                Toastify.success("Logged in successfully");
                localStorage.setItem("affiliatetoken",data.data.token)
                localStorage.removeItem("token")
        }                dispatch(AffiliategetProfile())


        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const AffiliateforgotPassword = createAsyncThunk('AffiliateforgotPassword', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.AffiliateforgotPassword(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setForgotPassword(body))
                Toastify.success("OTP sent successfully");
        }
        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const AffiliateverifyOtp = createAsyncThunk('AffiliateverifyOtp', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.AffiliateverifyOtp(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setVerifyOtp(body))
                Toastify.success("OTP Verified successfully");
        }
        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const AffiliateresetPassword = createAsyncThunk('AffiliateresetPassword', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.AffiliateresetPassword(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setResetPassword(body))
                Toastify.success("Password Reset successfully");
        }
        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)


export const affiliateloginSlice = createSlice({
    name: "affiliatelogin",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setLoginData: (state, action) => {
            state.loginInfo = action.payload
        },
        setForgotPassword: (state, action) => {
            state.forgotPasswordData = action.payload
        },
        setVerifyOtp: (state, action) => {
            state.verifyOtpData = action.payload
        },
        setResetPassword: (state, action) => {
            state.resetPasswordData = action.payload
        },
        
    },
    
})

export const { setLoading,setLoginData,setForgotPassword,setVerifyOtp,setResetPassword } = affiliateloginSlice.actions

export default affiliateloginSlice.reducer;